import React from 'react'
import { useTheme } from '@ow/theme'
import PropTypes from 'prop-types'
import StyleTooltip from './styled/tooltip'

const Tooltip = (props) => {
  const {
    className,
    style,
    children,
    on,
    trigger,
    offsetX,
    offsetY,
    position,
    arrow,
    mouseEnterDelay,
    mouseLeaveDelay,
    arrowStyle,
    keepTooltipInside,
  } = props

  const { themeClass } = useTheme()

  return (
    <StyleTooltip
      className={className}
      trigger={trigger}
      position={position}
      on={on}
      arrow={arrow}
      offsetX={offsetX}
      offsetY={offsetY}
      mouseEnterDelay={mouseEnterDelay}
      mouseLeaveDelay={mouseLeaveDelay}
      contentStyle={style}
      arrowStyle={arrowStyle}
      keepTooltipInside={keepTooltipInside}
    >
      <span className={themeClass}>{children}</span>
    </StyleTooltip>
  )
}

// 参数类型
Tooltip.propTypes = {
  style: PropTypes.shape({}),
  className: PropTypes.string,
  trigger: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  on: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  position: PropTypes.string,
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  arrow: PropTypes.bool,
  mouseEnterDelay: PropTypes.number,
  mouseLeaveDelay: PropTypes.number,
  arrowStyle: PropTypes.shape({}),
  keepTooltipInside: PropTypes.bool,
}
Tooltip.defaultProps = {
  className: undefined,
  style: undefined,
  children: undefined,
  on: undefined,
  trigger: undefined,
  offsetX: undefined,
  offsetY: undefined,
  position: undefined,
  arrow: undefined,
  mouseEnterDelay: undefined,
  mouseLeaveDelay: undefined,
  arrowStyle: undefined,
  keepTooltipInside: undefined,
}
export default Tooltip
